// extracted by mini-css-extract-plugin
export default {"wrapper":"walk-in-list_wrapper__Xa7mn","innerWrapper":"walk-in-list_innerWrapper__u701K","reason":"walk-in-list_reason__SqXSp"};